<div class="ib-overlay-fly ib-overlay-fly--type-3" *ngIf="sending && !sendOk && !sendError">
    <div class="ib-overlay-fly__container">
        <div class="ib-overlay-fly__icon">
            <div class="circle"></div>
            <div class="circle"></div>
        </div>
        <span class="ib-overlay-fly__text">{{'CKI_BOARDING_PASSES_SENDING'|translate}}</span>
    </div>
</div>
<!-- OK -->
<div *ngIf="sendOk && !sendError" class="ib-overlay-fly ib-overlay-fly--type-3">
    <div class="ib-overlay-fly__container">
        <div id="iconLoading" class="ib-overlay-fly__border">
            <div id="initLoading" class="ib-overlay-fly__border-loading"></div>
            <div id="valid" class="ib-overlay-fly__border-valid icon-confirmacion"></div>
        </div>
        <span class="ib-overlay-fly__text">{{'CKI_BOARDING_PASSES_SENT'|translate}}</span>
    </div>
</div>
<!-- KO -->
<div *ngIf="!sendOk && sendError" class="ib-overlay-fly ib-overlay-fly--type-3">
    <div class="ib-overlay-fly__container">
        <div id="iconLoading" class="ib-overlay-fly__border">
            <div id="initLoading" class="ib-overlay-fly__border-loading"></div>
            <div id="valid" class="ib-overlay-fly__border-error icon-cancelar"></div>
        </div>
        <span class="ib-overlay-fly__text">{{'CKI_BOARDING_PASSES_ERROR'|translate}}</span>
    </div>
</div>
